// Should replace openid_enum.ts
// This enumerates the parameters that the /mychart/auth endpoint accepts.
export enum LOGIN_PARAMS {
    BRAND = 'brand',
    EHR_SYSTEM = 'ehr_system',
    DEVICE_TYPE = 'device_type',
    CLIENT_ID = 'client_id', // allows the client to override the PIP client ID
    MOBILE = 'mobile', // mobile=true is a MyChart app specific query parameter.
    RESET_PASSWORD_FLOW = 'reset_password_flow',
    // REDIRECT_URI = 'redirect_uri', Redirect URI not supported. The redirect uri is always MyChart server and not adjustable.
    CANCEL_REDIRECT_URI = 'cancel_redirect_uri',
    // STATE = 'state', State is not supported. state cannot be passed to MyChart server.
    CORRELATION_ID = 'correlationId',
    LOGIN_HINT = 'login_hint', // prefill username
    ID_TOKEN_HINT = 'id_token_hint', // SPI-2231 for magic linking
    LANG = 'lang',
    CDP_DATA_B64 = 'cdpDataB64',
    AMPLITUDE_DEVICE_ID = 'deviceId', //Amplitude device Id generated and passed from Mychart. This param is required to stitch the cross domain amplitude events.
    AMPLITUDE_SESSION_ID = 'sessionId', //Amplitude session Id generated and passed from Mychart. This param is required to stitch the cross domain amplitude events.

    // MyChart native parameters
    FORCE_AUTHN = 'forceAuthn',
    LITE_MODE = 'liteMode',
    POSTLOGINURL = 'postloginurl',
    PIP_OAUTH_FLOW = 'pip_oauth_flow',

    // AIA related parameters
    EMAIL = 'aia_email', // same as login_hint
    BANNER_DEVICE = 'device',
    IS_AUTHORIZED = 'is_authorized',
    IS_AIA_LINK_EXPIRED = 'is_aia_link_expired',
}

export const ALLOWABLE_PARAMS: string[] = Object.values(LOGIN_PARAMS);

/**
 * List of parameters the register endpoint accepts.
 */
export enum REGISTER_PARAMS {
    CROSS_REGION = 'cross_region',
    REDIRECT_URI = 'redirect_uri',
}

/**
 * https://openid.net/specs/openid-connect-basic-1_0.html#RequestParameters
 *
 * Represents the custom list of parameters that the AzureB2C IdP accepts. Not exhaustive.
 */
export enum CUSTOM_OPENID_PARAMS {
    CSS_BRANDING = 'cssbranding',
    DISPLAY_MFA_FLOWS = 'display_mfa_flows',
    AMPLITUDE_DEVICE_ID = 'amp_device_id', //Amplitude device Id generated and passed from Mychart. This param is required to stitch the cross domain amplitude events.
    AMPLITUDE_SESSION_ID = 'amp_session_id', //Amplitude session Id generated and passed from Mychart. This param is required to stitch the cross domain amplitude events.
    SHOULD_DELAY_AMPLITUDE_SIGN_IN_TO_SAML_POLICY = 'should_delay_amplitude_sign_in_to_saml_policy', // This is a flag to indicate if we should delay the amplitude event for the sign in saml event.
}
